import axios from 'axios';
import { useEffect, useState } from 'react';

import { useLazyGetAccessTokenQuery } from '@hook/consumer/consumer.hooks';
import { ConnectionInterface, ConnectionStateEnum } from '@interface/connection/connection.interface';
import { ConsumerInterface } from '@interface/consumer/consumer.interface';
import { isString } from '@util/data/is-exist';

const connectionsByConsumerIdCache = new Map<string, ConnectionInterface[]>();

export const ConsumerIntegration = ({ consumer }: { consumer: ConsumerInterface }) => {
  const [getAccessToken, { data }] = useLazyGetAccessTokenQuery();
  const [connections, setConnections] = useState<ConnectionInterface[]>(
    () => connectionsByConsumerIdCache.get(consumer.id) ?? [],
  );

  useEffect(() => void getAccessToken(consumer), [consumer.id]);

  useEffect(() => {
    const cached = connectionsByConsumerIdCache.get(consumer.id);
    if (cached !== undefined) return;
    if (!isString((data as any)?.accessToken)) return;

    axios
      .get<{ data: ConnectionInterface[] }>(import.meta.env.VITE_API_SHARED_URL + '/connections', {
        headers: {
          authorization: `Bearer ${(data as any)?.accessToken}`,
        },
      })
      .then((response) => {
        const list = response.data.data
          .filter((connection) => connection.state === ConnectionStateEnum.Callable)
          .sort((a, b) => a.name.localeCompare(b.name));
        connectionsByConsumerIdCache.set(consumer.id, list);
        setConnections(list);
      })
      .catch(() => {
        // We just need to prevent the unhandled promise rejection
      });
  }, [consumer.id, (data as any)?.accessToken]);

  if (connections.length === 0) return <>List is empty</>;

  return <span>{connections.map((connection) => connection.name).join(', ')}</span>;
};
